import type { AppContextType } from "@/types/context-type";
import { api } from "./api";

export async function webDataApi(): Promise<AppContextType> {
    const res = await api.get("/web-data");
    return res.data;
}
